import { render, staticRenderFns } from "./LoginLandingPage.vue?vue&type=template&id=60e8ae4d&"
import script from "./LoginLandingPage.vue?vue&type=script&lang=js&"
export * from "./LoginLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports